"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = void 0;
var models_1 = require("../../../models");
var client_error_messages_1 = require("./client-error-messages");
exports.Errors = {
    checkAccessStatus: {
        developerMessage: client_error_messages_1.ClientErrorMessages.CHECK_ACCESS_STATUS,
        errorCode: models_1.ErrorCode.NotFound,
        userMessageBody: client_error_messages_1.ClientErrorMessages.CHECK_ACCESS_STATUS,
        userMessageTitle: client_error_messages_1.ClientErrorMessages.CHECK_ACCESS_STATUS,
    },
    checkActivationCodeStatusChange: {
        developerMessage: client_error_messages_1.ClientErrorMessages.CHECK_ACTIVATION_CODE_STATUS_CHANGE,
        errorCode: models_1.ErrorCode.CheckActivationCodeStatusChangeClientTimeOut,
        userMessageBody: client_error_messages_1.ClientErrorMessages.CHECK_ACTIVATION_CODE_STATUS_CHANGE,
        userMessageTitle: client_error_messages_1.ClientErrorMessages.CHECK_ACTIVATION_CODE_STATUS_CHANGE,
    },
    fallback: {
        developerMessage: client_error_messages_1.ClientErrorMessages.FALLBACK,
        errorCode: models_1.ErrorCode.NotFound,
        userMessageBody: client_error_messages_1.ClientErrorMessages.FALLBACK,
        userMessageTitle: client_error_messages_1.ClientErrorMessages.FALLBACK,
    },
    getUserDetailsFromAccessMethod: {
        developerMessage: client_error_messages_1.ClientErrorMessages.GET_USER_ID,
        errorCode: models_1.ErrorCode.NotFound,
        userMessageBody: client_error_messages_1.ClientErrorMessages.GET_USER_ID,
        userMessageTitle: client_error_messages_1.ClientErrorMessages.GET_USER_ID,
    },
    missingRequiredParams: {
        developerMessage: client_error_messages_1.ClientErrorMessages.MISSING_REQUIRED_PARAMS,
        errorCode: models_1.ErrorCode.InvalidRequest,
        userMessageBody: client_error_messages_1.ClientErrorMessages.MISSING_REQUIRED_PARAMS,
        userMessageTitle: client_error_messages_1.ClientErrorMessages.MISSING_REQUIRED_PARAMS,
    },
};
